const moduleLoaders = {
    '@gsm/object-validator': () => import('@gsm/object-validator'),
    'auth0-js': () => import('auth0-js'),
    'classnames': () => import('classnames'),
    'dateformat': () => import('dateformat'),
    'format': () => import('format'),
    'jspdf': () => import('jspdf'),
    'jspdf-autotable': () => import('jspdf-autotable'),
    'jwt-decode': () => import('jwt-decode'),
    'q': () => import('q'),
    'react-bootstrap': () => import('react-bootstrap'),
    'react-csv': () => import('react-csv'),
    'react-day-picker': () => import('react-day-picker'),
    'react-day-picker/DayPickerInput': () => import('react-day-picker/DayPickerInput'),
    'react-dnd': () => import('react-dnd'),
    'react-dnd-html5-backend': () => import('react-dnd-html5-backend'),
    'react-dom': () => import('react-dom'),
    'react-helmet': () => import('react-helmet'),
    'react-input-autosize': () => import('react-input-autosize'),
    'redux-responsive': () => import('redux-responsive'),
    'react-router-bootstrap': () => import('react-router-bootstrap'),
    'react-router-navigation-prompt': () => import('react-router-navigation-prompt'),
    'react-virtualized/AutoSizer': () => import('react-virtualized/dist/es/AutoSizer'),
    'react-virtualized/InfiniteLoader': () => import('react-virtualized/dist/es/InfiniteLoader'),
    'react-virtualized/List': () => import('react-virtualized/dist/es/List'),
    'what-input': () => import('what-input')
}

export default class ModuleLazyLoaderService {

    static loadedModules = {}

    static load(moduleNamesProto) {

        const moduleNames = []
        if (Array.isArray(moduleNamesProto)) {
            moduleNames.push.apply(moduleNames, moduleNamesProto)
        }
        else {
            moduleNames.push(moduleNamesProto)
        }

        const me = this

        return Promise.all(moduleNames.map((name) => {
            if (!(name in moduleLoaders)) {
                const msg = `No Loader for '${name}'; did you forget to add it to the lazy loader?`
                return Promise.reject(new Error(msg))
            }
            if (name in me.loadedModules) {
                return Promise.resolve(me.loadedModules[name])
            }
            return new Promise((resolve, reject) => {
                try {
                    moduleLoaders[name]()
                        .then((m) => {
                            me.loadedModules[name] = m
                            resolve(m)
                        })
                        .catch((error) => {
                            /* eslint-disable no-console */
                            console.log(error.stack)
                            /* eslint-enable no-console */
                            const msg = `Loading module '${name}' failed`
                            reject(new Error(msg))
                        })
                }
                catch (error) {
                    /* eslint-disable no-console */
                    console.log(error.stack)
                    /* eslint-enable no-console */
                    reject(error)
                }
            })
        })).then(() => {
            return me.loadedModules
        })

    }

}



// WEBPACK FOOTER //
// src/services/module-lazy-loader/index.js